import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useSearchParams from "@/hooks/useSearchParams";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { getCurrentPageNumber } from "@/lib/pagination";
import { Pagination, Spinner, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useEffect } from "react";
import useSnackbar from "src/store/useSnackbar";
import useGetPointTransactions from "./hooks/useGetPointTransactions";
import PointTransactionItem from "./PointTransactionItem";
const POINT_TRANSACTION_LIMIT = 10;
const PointTransaction = ()=>{
    var _error_response, _pointTransactions_data;
    const router = useRouter();
    const searchParams = useSearchParams();
    const currentPage = searchParams.get("page") ? Number(searchParams.get("page")) : 1;
    const { addSnackbar  } = useSnackbar();
    const { data: pointTransactions , isLoading , isError , error  } = useGetPointTransactions({
        offset: (currentPage - 1) * POINT_TRANSACTION_LIMIT,
        limit: POINT_TRANSACTION_LIMIT,
        groupByOrder: true
    });
    const is500Error = isError && (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 500;
    useEffect(()=>{
        if (is500Error) {
            addSnackbar({
                message: "다시 시도해주세요.",
                variant: "error"
            });
        }
    }, [
        is500Error
    ]);
    const shouldShowPagination = (pointTransactions === null || pointTransactions === void 0 ? void 0 : pointTransactions.pagination.total) > 0;
    var _pointTransactions_pagination_total;
    const totalPages = getCurrentPageNumber({
        total: (_pointTransactions_pagination_total = pointTransactions === null || pointTransactions === void 0 ? void 0 : pointTransactions.pagination.total) !== null && _pointTransactions_pagination_total !== void 0 ? _pointTransactions_pagination_total : 0,
        limit: POINT_TRANSACTION_LIMIT,
        rowCount: 0
    });
    const onChangePaginate = (selectedPage)=>{
        mixpanelEvent("Pagination UI Clicked", {
            Position: "포인트",
            "Button Name": "".concat(selectedPage, "페이지")
        });
        router.push({
            pathname: router.pathname,
            query: {
                ...router.query,
                page: selectedPage.toString()
            }
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white border border-gray-100 rounded-md rounded-t-none border-t-0 border-b-0",
                children: isLoading || is500Error ? /*#__PURE__*/ _jsx("div", {
                    className: "h-[200px] flex items-center justify-center",
                    children: /*#__PURE__*/ _jsx(Spinner, {
                        size: "lg",
                        className: "text-primary-main"
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: (pointTransactions === null || pointTransactions === void 0 ? void 0 : pointTransactions.pagination.total) > 0 ? pointTransactions === null || pointTransactions === void 0 ? void 0 : (_pointTransactions_data = pointTransactions.data) === null || _pointTransactions_data === void 0 ? void 0 : _pointTransactions_data.map((transaction)=>/*#__PURE__*/ _jsx(PointTransactionItem, {
                            transaction: transaction
                        }, transaction.id)) : /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-muted h-[200px] flex items-center justify-center",
                        children: "포인트 내역이 없어요."
                    })
                })
            }),
            shouldShowPagination && /*#__PURE__*/ _jsx(Pagination, {
                totalPages: totalPages,
                currentPage: currentPage,
                onPageChange: onChangePaginate,
                className: "flex items-center justify-center px-5 pt-6"
            })
        ]
    });
};
export default PointTransaction;
